import isEqual from 'lodash/isEqual';

/**
 * Sort and check if two arrays are equal.
 * Arrays are copied/spread because array is freezed in strict mode.
 */
export function arrayIsEqual<T>(array1: T[], array2: T[]): boolean {
  return isEqual([...array1].sort(), [...array2].sort());
}
